// 覆盖原生方法
export function toFixed () {
  Number.prototype.toFixed = function (s) {
    let that = this, changenum, index;
    if (this < 0) {
      that = -that
    }
    changenum = (parseInt(that * Math.pow(10, s) + 0.5) / Math.pow(10, s)).toString();
    index = changenum.indexOf(".")
    if (index < 0 && s > 0) {
      changenum = changenum + "."
      for (let i = 0; i < s; i++) {
        changenum = changenum + "0"
      }
    } else {
      index = changenum.length - index
      for (let i = 0; i < (s - index) + 1; i++) {
        changenum = changenum + "0"
      }
    }
    if (this < 0) {
      return -changenum
    } else {
      return changenum
    }
  }
}



// WEBPACK FOOTER //
// ./utils/overwriting.js